import { render, staticRenderFns } from "./HeadNotice.vue?vue&type=template&id=65c8564a&scoped=true"
import script from "./HeadNotice.vue?vue&type=script&lang=js"
export * from "./HeadNotice.vue?vue&type=script&lang=js"
import style0 from "./HeadNotice.vue?vue&type=style&index=0&id=65c8564a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c8564a",
  null
  
)

export default component.exports